module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; __append("<article class=\"grid-view-item live-event\">\n    <a class=\"link ")
    ;  if (!isLive){ 
    ; __append("upcoming")
    ;  } 
    ; __append("\" href=\"")
    ; __append(escapeFn( url ))
    ; __append("\" aa-link=\"")
    ; __append(escapeFn( aaLink ))
    ; __append("\"\n    >\n        <div class=\"thumb-wrapper\">\n            <img class=\"thumb lazy\"\n                 data-src=\"")
    ; __append(escapeFn( thumb ))
    ; __append("\"\n                 alt=\"")
    ; __append(escapeFn( title ))
    ; __append("\"/>\n\n            ")
    ;  if(status === 'PREMIUM' && !isUserSubscriber) { 
    ; __append("\n            <span class=\"label subscribe\">Subscribe</span>\n            ")
    ;  } 
    ; __append("\n        </div>\n    </a>\n    <div class=\"info-wrapper\">\n        <div class=\"air-time-container\">\n            ")
    ;   if (isLive){ 
    ; __append("\n            <div class=\"live-indicator\">\n                <span class=\"reddot\"></span>\n                <span class=\"live-icon-copy\">LIVE</span>\n            </div>\n            <span class=\"event-time\">")
    ; __append(escapeFn( inProgressTime ))
    ; __append("</span>\n            </span>\n            ")
    ;  } else { 
    ; __append("\n            <span class=\"event-time\"></span>\n            <input class=\"event-timestamp\" type=\"hidden\" value=\"")
    ; __append(escapeFn( startTimestamp ))
    ; __append("\">\n            ")
    ;  } 
    ; __append("\n            <span class=\"bell\"></span>\n        </div>\n        <div class=\"title-wrapper\">\n            <span class=\"title\">\n                ")
    ; __append(escapeFn( title ))
    ; __append("\n            </span>\n        </div>\n    </div>\n</article>\n")
  }
  return __output;

}